import { DataTable } from '@kc-console/shared-ui';

import { useEventsTableProps } from './EventsControllerProvider';

/**
 * 이벤트 내역 목록의 본문.
 * @description
 * - 서버 사이드 페이지네이션 DataTable을 구성한다.
 * - 필터 패널에 제목(title) 검색, 기간 프리셋(segment), 직접 선택(dateRange) 필터를 제공한다.
 * - 제목(title) 필터 값은 서버 파라미터로 전달한다.
 * @example
 * <EventsContent />
 */
const EventsContent = () => {
  const tableProps = useEventsTableProps();
  return <DataTable {...tableProps} stickyHeader showSideBorder={false} showSideMargin />;
};

export default EventsContent;
